export var isMobile = {
  Android: function() {
    return navigator.userAgent.match(/Android/i)
  },
  BlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i)
  },
  iOS: function() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i)
  },
  Opera: function() {
    return navigator.userAgent.match(/Opera Mini/i)
  },
  Windows: function() {
    return navigator.userAgent.match(/IEMobile/i)
  },
  any: function() {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
  }
}

export function decimalToString(value) 
{
  let decimalSeparator = ','
  let thousandSeparator = '.'

  // obtengo la parte entera y decimal
  value = parseFloat(value).toFixed(2)
  let integerPart = value.split('.')[0]
  let decimalPart = value.split('.')[1]

  // formateo la parte entera
  let i=integerPart.length-1
  let integerCount = 0
  let integerFormated = ''
  while(i >= 0)
  {
    // concateno el entero al formateado
    integerFormated = integerPart[i] + integerFormated
    integerCount++

    // agrego el separador de mil
    if(integerCount === 3 && i != 0)
    {
      integerFormated = thousandSeparator + integerFormated
      integerCount = 0
    }

    i--
  }

  return `${integerFormated}${decimalSeparator}${decimalPart}` 
}